import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { AuthState } from '../store/auth/types';

export default function useUser() {
    const { user } = useSelector<RootState, AuthState>((state) => state.auth);
    return user;
}
